export enum PlantypeEnum {
  PAND_TRANSFORMATIE = 'Pand Transformatie',
  TRANSFORMATIEGEBIED = 'Transformatiegebied',
  HERSTRUCTURERING = 'Herstructurering',
  VERDICHTING = 'Verdichting',
  UITBREIDING_UITLEG = 'Uitbreiding uitleg',
  UITBREIDING_OVERIG = 'Uitbreiding overig',
}
